import Layout from "../../Internal/Layout.vue";
import ResaleStock from "./resaleStock.vue";

const ResaleStockRoutes = {
  component: Layout,
  children: [
    {
      path: "/resale-stock",
      name: "ResaleStock",
      component: ResaleStock,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresManagerial: true,
      },
    },
  ],
};

export default ResaleStockRoutes;
